import TagManager from 'react-gtm-module';

export const triggerEvent = (event: string, payload?: object) =>
  TagManager.dataLayer({ dataLayer: { event, ...payload } });

export const triggerExportExcelEvent = () => triggerEvent('export_excel');
export const triggerCreateAppEvent = (applicationType: string) =>
  triggerEvent('create_application', { applicationType });
